import { Button, Center, Container, Stack, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container>
      <Stack>
        <Center>
          <Title order={1}>
            {"Looks like this page isn't implemented yet. Tell the devs to get on it!"}
          </Title>
        </Center>
        <Center>
          <Button fullWidth onClick={() => navigate('/')} color="blue">
            Go Home
          </Button>
        </Center>
      </Stack>
    </Container>
  );
}

export default NotFoundPage;
